import { Box, Tabs, Tab } from 'components'
import { Route, Routes, useParams } from 'react-router-dom'
import { useStateValue } from 'providers'
import { KaraokeSearch, KaraokeQueue } from '../components'
import styled from 'styled-components'

const Container = styled(Box)`
  width: 100vw;
  align-self: stretch;
  padding: 0.5rem 1rem;
`

export const UserKaraokeShow = () => {
  const [{ session }] = useStateValue()
  const { slug } = useParams()
  return (
    <Container>
      <Tabs>
        <Tab end to={`${session.user ? '/games' : '/guest'}/karaoke/${slug}`}>
          search
        </Tab>
        <Tab to={`${session.user ? '/games' : '/guest'}/karaoke/${slug}/queue`}>
          queue
        </Tab>
      </Tabs>
      <Routes>
        <Route
          path={'/'}
          element={
            <KaraokeSearch
              user={session?.user || { full_name: 'anon' }}
              guest={true}
            />
          }
        />
        <Route path={'/queue'} element={<KaraokeQueue user={session?.user || { full_name: 'anon' }} guest={!session?.user} />} />
      </Routes>
    </Container>
  )
}
